export const rule = _node => {
  return '----';
};